import React from 'react';
import styled from 'styled-components';

import {
  func
} from 'prop-types';

const TooltipContainer = styled.div`
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
`;
TooltipContainer.displayName = 'TooltipContainer';

const TooltipOverlay = styled.div`
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  overflow: hidden;

  pointer-events: none;
`;
TooltipOverlay.displayName = 'TooltipOverlay';

class TooltipProvider extends React.Component {
  static childContextTypes = {
    getOverlay: func
  };
  getChildContext() {
    return {
      getOverlay: () => this.overlay
    };
  }
  render() {
    return (
      <TooltipContainer>
        {this.props.children}
        <TooltipOverlay innerRef={r => this.overlay = r} />
      </TooltipContainer>
    );
  }
}

export default TooltipProvider;


// WEBPACK FOOTER //
// ./src/components/Tooltips/TooltipProvider.js